import { LoadingButton } from '@mui/lab';
import { Button, Stack, Typography } from '@mui/material';
import { PromptDialogOnSide } from 'common/components/PromptDialogOnSide/PromptDialogOnSide';
import { styles } from 'common/components/PromptDialogOnSide/PromptDialogOnSide.styles';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { useNotification } from 'common/hooks/useNotification';
import { useDeleteFinancialReserveMutation } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

export interface DeleteFinancialReserveDialogProps extends DialogComponentProps<boolean> {
  id: string;
}

export const DeleteFinancialReserveDialog: React.FC<DeleteFinancialReserveDialogProps> = ({
  id,
  isOpen,
  onResolve,
}) => {
  const { t } = useTranslation();
  const notify = useNotification();

  const [deleteFinancialReserve, { loading }] = useDeleteFinancialReserveMutation({
    onCompleted: (resp) => {
      if (resp.deleteFinancialReserve) {
        onResolve(true);
      }
    },
    onError: () => {
      notify({ message: t('common:somethingWentWrong'), type: 'error' });
      onResolve(false);
    },
    refetchQueries: ['FinancialReserves'],
  });

  const handleDelete = async () => {
    if (!loading) {
      await deleteFinancialReserve({ variables: { id } });
    }
  };

  return (
    <PromptDialogOnSide
      onClose={() => onResolve(false)}
      open={isOpen}
      title={t('fintelligenceReport.deleteFinancialReserveDialog.title')}
    >
      <Stack spacing={1}>
        <LoadingButton color="tertiaryButton" loading={loading} onClick={handleDelete} sx={styles.button}>
          <Typography color="red.dark" variant="bodyL">
            {t('fintelligenceReport.deleteFinancialReserveDialog.button')}
          </Typography>
        </LoadingButton>
        <Button color="tertiaryButton" onClick={() => onResolve(false)} sx={styles.button}>
          <Typography color="blue.dark" variant="bodyStrongL">
            {t('common:cancel')}
          </Typography>
        </Button>
      </Stack>
    </PromptDialogOnSide>
  );
};
